import React from "react";
import { BoardItem } from "./BoardItem";
import { IBoardLaneProps } from "./BoardLane";
import styles from "./mobileBoardLane.module.scss";

const MobileBoardLane: React.FC<IBoardLaneProps> = (props: IBoardLaneProps) => {
    return (
        <div className={styles.wrapper}>
            {props.preparedItems?.length
                ? props.preparedItems.map((item) => (
                      <BoardItem
                          key={`Board__DraggableItem__${item.itemKey}`}
                          item={item}
                          users={props.users}
                          translations={props.t}
                          boardItemCardLayout={props.boardItemCardLayout}
                          onClick={props.onItemClick}
                          chosenTaskId={props.chosenTaskId}
                      />
                  ))
                : null}
        </div>
    );
};

export default MobileBoardLane;
